import React from 'react';
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import Layout from './components/Layout';
import Marketplace from './pages/Marketplace/Marketplace'
import MyLibrary from "./pages/MyLibrary";

import './App.css';

const App = () => {
    return (
        <Layout>
            <Router>
                <Routes>
                    <Route path="/marketplace" element={<Marketplace/>}/>
                </Routes>
                <Routes>
                    <Route path="/projects" element={<MyLibrary/>}/>
                </Routes>
                <Routes>
                    <Route path="/redeem" element={<MyLibrary/>}/>
                </Routes>
            </Router>
        </Layout>
    );
}

export default App;